import { StyleSheet } from 'react-native';
import { AppTheme } from '../../../theme';

export const addEditProductStyle = (theme: AppTheme) => StyleSheet.create({
  containerView: {
    flex: 1,
    backgroundColor: theme.light,
  },
  headerView: {
    flexDirection: 'row',
    margin: 10,
    justifyContent: 'center',
    alignSelf: 'flex-end',
    marginBottom: 10,
  },
  buttonContainerStyle: {
    marginHorizontal: 5,
  },
  buttonStyle: {
    backgroundColor: theme.primary,
    borderRadius: 7,
    width: 100,
    borderWidth: 1,
  },
  buttonStyle1: {
    backgroundColor: theme.light,
    borderColor: theme.grey,
    borderRadius: 7,
  },
  buttonTitleStyle: {
    color: theme.light,
    fontSize: theme.smallHeaderFontSize,
  },
  buttonTitleStyle1: {
    color: theme.grey,
    fontSize: theme.smallHeaderFontSize,
  },
  outlineButtonTitleStyle: {
    color: theme.primary,
    fontSize: theme.smallHeaderFontSize,
  },
  /**
   * Web only (applied behind a Platform check in productGeneral).
   *
   * `flex: 1` gives this row flex-basis 0, pinning it to the scroll
   * viewport so the columns inside are capped and their cards overflow.
   * Growing from a content basis lets the row be as tall as its taller
   * column and lets the ScrollView scroll. `flex: undefined` clears the
   * shorthand that comes before it in the style array.
   */
  webContentHeightRow: {
    flex: undefined,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
  },
  generalDetailsView: {
    flex: 1,
    paddingTop: 5,
    backgroundColor: theme.light,
  },
  labelStyle: {
    fontSize: theme.smallerFontSize,
    color: theme.labelColor,
  },
  errorStyle: {
    fontSize: theme.errorFontSize,
    fontFamily: theme.medium,
    color: theme?.red,
  },
  leftIconContainerStyle: {
    backgroundColor: theme.lightBackgroundColor,
    padding: 5,
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
    height: '100%',
    width: 50,
    position: 'absolute',
  },
  viewStyle: {
    backgroundColor: theme.light,
    borderRadius: 16,
  },
  viewStyle1: {
    flexDirection: 'row',
    borderColor: theme.lightGrey,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  textStyle: {
    padding: 5,
    color: theme.lightDark,
    fontFamily: theme.bold,
    fontSize: theme.smallFontSize,
  },
  textStyle1: {
    textAlign: 'center',
    backgroundColor: theme.lightBackgroundColor,
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  containerStyle: {
    height: 40,
    width: 90,
  },
  titleStyle: {
    color: theme.primary,
    fontFamily: theme.bold,
    fontSize: theme.mediumFontSize,
  },
  flex: { flex: 1 },
  modifierVariantHeader: {
    backgroundColor: theme.light,
    margin: 10,
    padding: 10,
    borderRadius: 8,
    elevation: 1,
  },
  modifierVariantHeaderText: { textAlign: 'left', paddingBottom: 5 },
  modifierDropdownView: { flex: 1 },
  modifierListView: {
    backgroundColor: theme.light,
    margin: 10,
    padding: 10,
    borderRadius: 8,
    elevation: 2,
    flex: 1,
  },
  modifierListSubView: { marginVertical: 10 },
  modifierListMinMaxSectionView: { flexDirection: 'row', flex: 1 },
  modifierListOptionSectionView: { marginTop: 10, zIndex: -1 },
  variantFlexdirection: { flexDirection: 'row' },
  variantButtonStyle: {
    height: 40,
    borderRadius: 7,
    backgroundColor: theme.primary,
    borderColor: theme.primary,
    marginLeft: 10,
    marginTop: 5,
  },
  variantImageView: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginVertical: 10,
  },
  variantImageCloseIconView: {
    top: -6,
    backgroundColor: theme.light,
    borderRadius: 16,
    right: 10,
    height: 18,
  },
  variantImageContainerStyle: {
    marginBottom: 10,
    alignItems: 'center',
    right: 10,
  },
  variantImageButtonStyle: {
    backgroundColor: theme.light,
    borderColor: theme.primary,
    borderRadius: 7,
  },
  variantImageTitleStyle: {
    color: theme.primary,
    fontSize: theme.smallHeaderFontSize,
  },
  variantSKUTooltipStyle: {
    color: theme.light,
    fontSize: theme.badgeFontSize,
    backgroundColor: theme.grey,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 8,
    alignSelf: 'flex-end',
    position: 'absolute',
    zIndex: 1,
    top: -25,
  },
  variantInputContainerStyle: { flex: 1 },
  variantLocationErrorMessage: {
    textAlign: 'left',
    fontSize: theme?.errorFontSize,
    fontFamily: theme?.medium,
    color: theme?.red,
    left: 5,
    zIndex: -100,
  },
  generalProductErrorMessage: { flexDirection: 'row', top: -15 },
  generalProductDescriptionInputContainerStyle: { marginTop: -5 },
  generalProductBrandDropdownView: {
    marginBottom: 20,
  },
  generalProductCountTooltip: {
    color: theme.light,
    fontSize: theme.badgeFontSize,
    backgroundColor: theme.grey,
    width: 120,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 16,
    alignSelf: 'flex-end',
    position: 'absolute',
    top: 20,
    zIndex: 1,
  },
  generalProductUnitCountContainerStyle: { marginTop: 10 },
  generalProductWeightDropdownView: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  generalProductDimensionContainerStyle: {
    flex: 0.33,
  },
  generalProductDimensionDropdownContainerStyle: {
    width: 100,
    right: `12%`,
    height: 75,
  },
  generalProductTooltipStyle: { marginLeft: 5 },
  generalProductSKUTooltip: {
    color: theme.light,
    fontSize: theme.badgeFontSize,
    backgroundColor: theme.grey,
    width: 120,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 16,
    alignSelf: 'flex-end',
    position: 'absolute',
    top: 20,
    zIndex: 1,
  },
  generalProductUPCTooltip: {
    color: theme.light,
    fontSize: theme.badgeFontSize,
    backgroundColor: theme.grey,
    width: 120,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 16,
    alignSelf: 'flex-end',
    position: 'absolute',
    top: 10,
    zIndex: 1,
  },
  generalProductCheckboxStyle: { right: 20 },
  generalProductAvailabilityStyle: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginVertical: 15,
  },
  generalProductSwitchView: { flexDirection: 'row', alignItems: 'center' },
  generalProductDateErrorMessage: {
    fontSize: theme?.errorFontSize,
    fontFamily: theme?.medium,
    color: theme?.red,
    paddingTop: 5,
  },
  generalProductLocationSectionContainer: {
    marginBottom: 20,
    padding: 15,
    backgroundColor: theme.light,
    borderRadius: 16,
    marginHorizontal: 10,
    flex: 1,
  },
  generalProductLocationView: {
    flex: 1,
    flexDirection: 'row',
    marginBottom: 10,
    borderWidth: 1,
    borderColor: theme.lightGrey,
    borderRadius: 16,
  },
  generalProductLocationErrorMessage: {
    fontSize: theme?.errorFontSize,
    fontFamily: theme?.medium,
    color: theme?.red,
    paddingHorizontal: 2,
  },
  checkboxStyle: {
    margin: 0,
    padding: 0,
    backgroundColor: 'transparent',
    borderColor: 'transparent',
  },
  locView:
  {
    borderWidth: 1,
    borderRadius: 1,
    borderColor: theme.lightGrey,
    paddingHorizontal: 10,
    paddingVertical: 20,
    marginHorizontal: 10,
  },
  /**
   * Web only, applied behind a Platform check at the call sites.
   *
   * The "Availability Location" heading sits in a `rowContainer`, which
   * centres its children, next to the "+ Add location" button. The heading
   * carries a `paddingBottom: 10` (and `top: 10` on the Variants tab) left
   * over from when it was stacked above the row, so centring puts its text
   * several pixels off the button's centre line - the button looks like it is
   * floating free of the heading. Clearing the leftover offsets is what puts
   * the two back on one baseline; the spacing below the row is owned by the
   * row's own marginBottom.
   */
  /**
   * Web only, applied behind a Platform check at the call sites.
   *
   * ZenInput renders its label at 14px (webField.labelFontSize), but the
   * Location dropdown writes its own label with `size={smallHeaderFontSize}`
   * - 12px on web. Three stacked fields in the Availability card therefore
   * carry two different label sizes, which is what makes the group look
   * ragged even though the controls themselves line up. Native keeps the
   * smaller label, where the size difference reads as hierarchy rather than
   * inconsistency.
   */
  webFieldLabel: {
    fontSize: theme.smallerFontSize,
  },
  /**
   * Web only, applied behind a Platform check at the call sites.
   *
   * A card written as `flex: 1` inside a column that is itself pinned to
   * the scroll viewport becomes *a share of the viewport* rather than the
   * height of what it holds, and its content then runs straight out of the
   * bottom of the card. Measured on the Availability Location card: 1500x196
   * around 306px of content - a 110px overhang that puts the location
   * fields outside the white panel they belong to.
   *
   * Not `flex: 0`: react-native-web passes that through as the CSS
   * shorthand, and CSS `flex: 0` means flex-basis 0, which collapses the
   * card instead. The longhands say what is actually wanted, and the
   * shorthand is cleared because RNW skips undefined values outright.
   *
   * Android stacks these cards in a single scrolling column where `flex: 1`
   * behaves, so the native style is left alone.
   */
  webCardAutoHeight: {
    flex: undefined,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto' as const,
  },
  webRowHeadingText: {
    paddingBottom: 0,
    top: 0,
  },
  rowContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  imgClose:
  {
    position: 'absolute',
    top: -11,
    right: -11,
    zIndex: 1
  },
  imgCloud:
  {
    position: 'absolute',
    bottom: -2,
    left: 2,
    zIndex: 1,
  },
  multiImageContainer: {
    flexDirection: 'row',
    flex: 1,
    flexWrap: 'wrap',
    borderWidth: 1,
    borderStyle: 'dashed',
    borderRadius: 1,
    borderColor: 'grey',
    padding: 10,
    paddingTop: 20
  },
  multiImgView:
  {
    marginBottom: 10,
    marginRight: 10,
    padding: 5,
    borderColor: theme.borderColor,
    borderWidth: 1,
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rootBackground: {
    flex: 1,
    backgroundColor: '#fff'
  },
  locSubView: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginRight: 2,
  },
  rightIcon: {
    borderWidth: 0.5,
    borderColor: theme.secondary,
    backgroundColor: theme.lightRed,
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  cancelButtonStyle: {
    borderRadius: 7,
    width: 100,
    borderWidth: 1,
    borderColor: theme.primary,
    backgroundColor: theme.light,
  },
  saveButtonStyle: {
    backgroundColor: theme.primary,
    borderRadius: 7,
    width: 100,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  transparentView: {
    backgroundColor: 'transparent',
  },
  popoverStyle: {
    borderRadius: 10,
  },
  scrollViewStyle: {
    backgroundColor: theme.lightBackgroundColor,
  },
  scrollViewContentContainer: {
    flexGrow: 1,
    paddingBottom: 50,
  },
  leftColumn: {
    paddingHorizontal: 10,
    flexDirection: 'column',
    gap: 15,
  },
  generalDetailsCard: {
    marginTop: 10,
    borderRadius: 16,
    paddingHorizontal: 15,
  },
  headerText: {
    marginTop: 10,
  },
  inputContainer: {
    paddingHorizontal: 8,
  },
  inputWrapper: {
    marginTop: 10,
  },
  input: {
    height: 40,
  },
  dropdownContainer: {
    marginVertical: 5,
  },
  marginBottom10: {
    marginBottom: 10,
  },
  flex07: {
    flex: 0.7,
  },
  weightUnitContainer: {
    flex: 0.3,
  },
  weightUnitDropdown: {
    height: 40,
    top: 4,
  },
  rowCenter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  seoTitle: {
    marginTop: 10,
    paddingBottom: 2,
    paddingLeft: 10,
  },
  seoCheck: {
    marginBottom: 10,
    paddingLeft: 10,
  },
  emptyStateText: {
    textAlign: 'center',
    marginTop: 10,
  },
  flex05: {
    flex: 0.5,
  },
  dropdownItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 10,
  },
  variantHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  variantHeaderRight: {
    flexDirection: 'row',
    gap: 15,
    alignItems: 'center',
  },
  iconMargin: {
    marginHorizontal: 6,
  },
  variantDetailsHeader: {
    justifyContent: 'space-between',
    marginVertical: 5,
  },
  variantSwitchContainer: {
    columnGap: 10,
  },
  switchRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  switchScale: {
    transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }],
  },
  rowSpaceBetween: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  imageListContainer: {
    flexDirection: 'row',
    columnGap: 10,
    flex: 1,
  },
  uploadBox: {
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1 / 6,
    borderWidth: 1,
    borderRadius: 12,
    borderColor: theme.borderColor,
  },
  imagesRow: {
    flexDirection: 'row',
    flex: 1,
    gap: 10,
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 12,
  },
  closeIcon: {
    position: 'absolute',
    top: -10,
    right: -10,
    zIndex: 1,
    borderRadius: 50,
    backgroundColor: theme.light,
  },
  imagePlaceholder: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: 10,
  },
  center: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  locationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5,
  },
  locationInputs: {
    gap: 10,
  },
  dropdownWrapper: {
    flex: 1,
    zIndex: 3,
  },
  textCapitalize: {
    textTransform: 'capitalize',
  },
  fullWidth: {
    width: '100%',
  },
  justifyCenter: {
    justifyContent: 'center',
  },
  stockContainer: {
    flex: 1,
    marginTop: 20,
  },
  checkboxTitle: {
    fontSize: theme.smallerFontSize,
    fontFamily: theme.medium,
  },
  checkboxWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
  },
  smallTextPadding: {
    fontSize: theme.smallFontSize,
    paddingVertical: 10,
  },
  subHeaderText: {
    paddingBottom: 10,
    paddingTop: 15,
    fontSize: theme.mediumFontSize,
  },
  inputPaddingLeft: {
    height: 40,
    paddingLeft: 45,
  },
  inputContainer10: {
    paddingHorizontal: 10,
  },
  currencyText: {
    color: theme.primary,
    fontSize: theme.smallHeaderFontSize,
    fontFamily: theme.bold,
  },
  smallText: {
    fontSize: theme.smallFontSize,
    paddingBottom: 10,
  },
  marginBottom0: {
    marginBottom: 0,
  },
  marginTop15: {
    marginTop: 15,
  },
  rightColumn: {
    gap: 15,
    paddingHorizontal: 10,
  },
  cardPadding: {
    marginTop: 10,
    padding: 15,
    gap: 10,
  },
  imageHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  imageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
  },
  imageBox: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: theme.borderColor,
    borderRadius: 12,
    maxWidth: 150,
  },
  uploadedImage: {
    alignSelf: 'center',
  },
  loaderContainer: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: 5,
  },
  absoluteFill: {
    ...StyleSheet.absoluteFillObject,
  },
  centerText: {
    flexWrap: 'wrap',
    textAlign: 'center',
  },
  mediumText: {
    fontSize: theme.mediumFontSize,
  },
  marginLeftMinus12: {
    marginLeft: -12,
  },
  smallFontSize: {
    fontSize: theme.smallFontSize,
  },
  subHeaderTextMedium: {
    paddingBottom: 10,
    fontSize: theme.mediumFontSize,
  },
  modifierDropdownContainer: {
    width: '100%',
    marginVertical: 15,
  },
  dropDownContainer: {
    position: 'relative',
    top: 0,
    bottom: 0,
  },
  emptyStateContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  marginTop9ZIndexMinus1: {
    marginTop: 9,
    zIndex: -1,
  },
  marginVertical5: {
    marginVertical: 5,
  },
  marginTop10: {
    marginTop: 10,
  },
  mediumLabelStyle: {
    fontSize: theme.smallerFontSize,
    color: theme.dark,
    fontFamily: theme.medium,
  },
  alignItemsEnd: {
    alignItems: 'flex-end',
  },
  variantCheckboxTitle: {
    fontSize: theme.smallerFontSize,
    marginVertical: 16,
    color: theme.lightDark,
  },
  variantCheckboxContainer: {
    columnGap: 15,
    paddingHorizontal: 15,
  },
  badgeContainer: {
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  marginHorizontal6: {
    marginHorizontal: 6,
  },
  variantOptionsWrapper: {
    flexDirection: 'column',
    paddingRight: 10,
    alignSelf: 'flex-end',
    columnGap: 10,
  },
  switchStyle: {
    transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }],
  },
  imageUploadContainer: {
    rowGap: 10,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.borderColor,
    padding: 10,
    flex: 1,
  },
  uploadPlaceholder: {
    flexDirection: "row",
    columnGap: 10,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  imagesListContainer: {
    borderWidth: 1,
    borderColor: theme.borderColor,
    borderRadius: 12,
    flexDirection: "row",
    padding: 5,
    columnGap: 10,
  },
  imageItemContainer: {
    padding: 10,
    borderWidth: 1,
    borderColor: theme.borderColor,
    borderRadius: 12,
    flex: 1 / 4,
    alignItems: "center",
    justifyContent: "center",
  },
  closeIconContainer: {
    right: 0,
    top: -5,
    position: "absolute",
    zIndex: 10,
  },
  cloudIcon: {
    position: 'absolute',
    bottom: -2,
    left: 2,
    zIndex: 1,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: 5,
    zIndex: 0,
  },
  availabilityHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  availabilityTitle: {
    top: 10,
    fontSize: theme.mediumFontSize,
  },
  variantStockContainer: {
    flex: 1,
    marginTop: 20,
    paddingHorizontal: 10,
  },
  checkBoxUnlimited: {
    marginTop: 15,
    flexDirection: 'row',
    flex: 1,
    marginRight: 5,
    paddingHorizontal: 10,
  },
  modalContainer: {
    flex: 1,
    backgroundColor: theme.transparentBackground,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: theme.light,
    borderRadius: 16,
  },
  modalHeader: {
    backgroundColor: theme.lightBackgroundColor,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  modalHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    height: 30,
    marginHorizontal: 20,
    marginVertical: 20,
  },
  modalTitle: {
    alignItems: 'flex-start',
    fontSize: theme.largerFontSize,
    fontFamily: theme.bold,
    color: theme.lightDark,
  },
  emptyListContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  saveButtonContainer: {
    alignSelf: "flex-end",
    flexDirection: 'row',
    marginVertical: 20,
    marginHorizontal: 20,
    justifyContent: "space-between",
  },
  saveButton: {
    borderRadius: 7,
    backgroundColor: theme.primary,
    borderColor: theme.primary,
    marginLeft: 10,
  },
  padding15: {
    padding: 15,
  },
  paddingVertical20: {
    paddingVertical: 20,
  },
  centerItems: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadImageButton: {
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1 / 6,
    borderWidth: 1,
    borderColor: theme.borderColor,
    borderRadius: 12,
  },

});
